import COS from "cos-js-sdk-v5";
import axios from 'axios';

const Bucket = 'sday-1302279626';		/* 存储桶，必须字段 */
const Region = 'ap-hongkong';			/* 存储桶所在地域，必须字段 */

// 初始化实例
const cos = new COS({

	getAuthorization: function (options, callback) {

		axios.get('/sday/cos-sts', {
			bucket: options.Bucket,
			region: options.Region
		}).then(function (res) {
			if (res.data.success) {
				var credentials = res.data.TokenSts && res.data.TokenSts.credentials;
				if (!res.data.TokenSts || !credentials) return console.error('credentials invalid');
				callback({
					TmpSecretId: credentials.tmpSecretId,
					TmpSecretKey: credentials.tmpSecretKey,
					XCosSecurityToken: credentials.sessionToken,
					// 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
					StartTime: res.data.TokenSts.startTime, // 时间戳，单位秒，如：1580000000
					ExpiredTime: res.data.TokenSts.expiredTime // 时间戳，单位秒，如：1580000900
				});
			}
		}).catch(function (err) {
			console.log(err);
		}).then(function () {
			// always executed
		});

	}

});

export { cos, Bucket, Region };